// Mini gráfico de linha (SVG inline, sem dependência externa).
export function Sparkline({
    data, width = 96, height = 28, color = '#94a3b8', strokeWidth = 1.5, fill = true,
}: {
    data?: number[];
    width?: number;
    height?: number;
    color?: string;
    strokeWidth?: number;
    fill?: boolean;
}) {
    const series = (data ?? []).map((v) => (Number.isFinite(v) ? v : 0));
    if (series.length < 2) {
        return <svg width={width} height={height} className="overflow-visible" />;
    }
    const max = Math.max(...series);
    const min = Math.min(...series);
    const span = max - min || 1;
    const pad = strokeWidth + 1;
    const w = width - pad * 2;
    const h = height - pad * 2;
    const stepX = w / (series.length - 1);
    const pts = series.map((v, i) => {
        const x = pad + i * stepX;
        const y = pad + h - ((v - min) / span) * h;
        return [x, y] as const;
    });
    const line = pts.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
    const area = `${line} L${pts[pts.length - 1][0].toFixed(1)},${(height - pad).toFixed(1)} L${pts[0][0].toFixed(1)},${(height - pad).toFixed(1)} Z`;
    const gid = `spark-${Math.round(pts[0][1])}-${series.length}-${Math.round(max)}`;
    return (
        <svg width={width} height={height} className="overflow-visible">
            {fill && (
                <>
                    <defs>
                        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor={color} stopOpacity={0.18} />
                            <stop offset="100%" stopColor={color} stopOpacity={0} />
                        </linearGradient>
                    </defs>
                    <path d={area} fill={`url(#${gid})`} stroke="none" />
                </>
            )}
            <path d={line} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" />
        </svg>
    );
}
